import React from "react";
import { Link } from "react-router-dom";
import LogOut from "../../components/LogOut/LogOut";
import styles from "./Header.module.scss";
import { Button, HStack } from "@chakra-ui/react";
import CatLogo from "../../assets/images/gg-cat-logo-lockup.svg";

let logo;

function Header({ loggedIn, text }) {
  const queryParams = new URLSearchParams(window.location.search);
  const isPresentationMode = queryParams.get("layoutMode") === "presentation";
  if (loggedIn) {
    logo = (
      <div className={styles.headerWrapper}>
        <Button as={Link} to="/" variant="ghost" px={0}>
          <div className={styles.cat}>
            <CatLogo className={styles.catLogo} />
          </div>
        </Button>
        <LogOut />
      </div>
    );
  } else {
    logo = (
      <div className={`${styles.cat} ${styles.noLink}`}>
        <CatLogo className={styles.catLogo} />
      </div>
    );
  }

  return (
    <HStack
      className={styles.header}
      display={isPresentationMode ? "none" : "flex"}
    >
      <div className={styles.headerInner}>{logo}</div>
    </HStack>
  );
}

export default Header;
